import { ChangeEvent } from 'react';
import styled from 'styled-components';

interface EditableTextCellProps {
  value: string | null;
  onUpdate: (newValue: string | null) => void;
  placeholder?: string;
  hasError?: boolean;
}

/**
 * Editable free-text cell for the site-locations table. Empty input maps to `null` so the
 * save payload distinguishes "cleared" from "untouched". Mirrors the styling of the generic
 * editable-percentage-cell so the site table looks consistent with the operational-data one.
 */
export function EditableTextCell({ value, onUpdate, placeholder, hasError }: EditableTextCellProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    onUpdate(text === '' ? null : text);
  };

  return (
    <InputCellWrapper $hasError={hasError}>
      <input type="text" value={value ?? ''} onChange={handleChange} placeholder={placeholder} />
    </InputCellWrapper>
  );
}

const InputCellWrapper = styled.div<{ $hasError?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;

  input {
    flex: 1;
    min-width: 0;
    font-size: var(--font-size__md);
    padding: 4px 8px;
    border: 1px solid ${props => (props.$hasError ? 'var(--borderColor-danger-emphasis)' : 'var(--borderColor-default)')};
    border-radius: var(--border-radius__xs);

    &:focus-visible {
      outline: var(--focus-ring__width) solid var(--focus-ring__color);
      outline-offset: -1px;
    }
  }
`;
